import React from "react";

import AddIcon from "@mui/icons-material/Add";
import { Box } from "@mui/material";

export const AddValueButton: React.FC<{ onClick?: (e: React.MouseEvent<HTMLDivElement>) => void }> = ({ onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      display: "inline-flex",
      alignItems: "center",
      padding: "4px",
      borderRadius: "32px",
      cursor: "pointer",
      transition: "padding 0.2s ease, background-color 0.2s ease",
      bgcolor: "#f5f6f7",
      "& .add-value-label": {
        maxWidth: 0,
        opacity: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        fontSize: "12px",
        color: "#071f35",
        lineHeight: 1,
        transition: "max-width 0.2s ease, opacity 0.2s ease"
      },
      "&:hover": {
        padding: "4px 8px",
        bgcolor: "rgba(7, 31, 53, 0.04)",
        "& .add-value-label": {
          maxWidth: "80px",
          opacity: 1
        },
        "& .add-value-icon": {
          color: "#071f35"
        }
      }
    }}
  >
    <AddIcon className="add-value-icon" sx={{ fontSize: 16, color: "#8e99a3" }} />
    <Box component="span" className="add-value-label">
      Add Value
    </Box>
  </Box>
);
